var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"alerts"}},_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:index},[_c('v-alert',{class:alert.class,attrs:{"type":alert.type,"dismissible":""}},[_vm._v(" "+_vm._s(alert.message)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }